import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { BackFromCustomerDetailIcon } from "../../assets";
import {
  SCREEN_PATH,
  EMPTY_STRING,
  countriesEcncylopediaConstants,
} from "../../constants";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import CountryFlag from "../../shared/components/country-flag/CountryFlag";
import convertContentToHTML from "../../shared/utility-functions/ConvertContentToHtml";
import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import { countriesEncyclopediaActions } from "../../redux/actions";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";

const { GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID } =
  countriesEcncylopediaConstants;

const CountriesEncyclopediaDetail = (props) => {
  const {
    spinnerActions,
    countryEncyclopediaDetail,
    getCountryEncyclopediaDetailById,
  } = props;

  const navigate = useNavigate();
  const { countryEncyclopediaId } = useParams();
  const [htmlContent, setHtmlContent] = useState(EMPTY_STRING);

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  const navigateToCountriesEncyclopedia = () => {
    navigate(SCREEN_PATH.COUNTRIES_ENCYCLOPEDIA, { replace: true });
  };

  useEffect(() => {
    if (countryEncyclopediaDetail?.content) {
      const html = convertContentToHTML(countryEncyclopediaDetail.content);
      setHtmlContent(html);
    }
  }, [countryEncyclopediaDetail]);

  useEffect(() => {
    if (countryEncyclopediaId) {
      getCountryEncyclopediaDetailById(countryEncyclopediaId);
    }
    // eslint-disable-next-line
  }, [countryEncyclopediaId]);

  return (
    <>
      <Topbar />
      {spinner(GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID) > -1 && <MainSpinner />}
      <MainContentWrapper>
        <div className="container countries-encyclopedia-detail">
          <img
            src={BackFromCustomerDetailIcon}
            className="back-icon pointer"
            onClick={navigateToCountriesEncyclopedia}
            alt="Back"
          />
          <div className="d-flex align-items-center">
            <CountryFlag
              width={36}
              height={26}
              countryCode={countryEncyclopediaDetail?.country?.code}
            />
            <div className="heading">
              {countryEncyclopediaDetail?.country?.name}
            </div>
          </div>
          {spinner(GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID) === -1 && (
            <div
              dangerouslySetInnerHTML={{ __html: htmlContent }}
              className="mt-4"
            />
          )}
        </div>
      </MainContentWrapper>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  countryEncyclopediaDetail:
    state.countriesEncyclopediaReducer.countryEncyclopediaDetail,
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  getCountryEncyclopediaDetailById: (id) =>
    dispatch(countriesEncyclopediaActions.getCountryEncyclopediaDetailById(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CountriesEncyclopediaDetail);
